import { render, staticRenderFns } from "./TableCard.vue?vue&type=template&id=3ca98e02&scoped=true"
import script from "./TableCard.vue?vue&type=script&lang=ts"
export * from "./TableCard.vue?vue&type=script&lang=ts"
import style0 from "./TableCard.vue?vue&type=style&index=0&id=3ca98e02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca98e02",
  null
  
)

export default component.exports